import React from 'react'
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const DetailsRow = ({item}) => 
    <Box display="flex" mb={1.5} flexDirection={{xs:"column", lg:"row"}}>
        <Box width={{xs:"100%", lg:"300px"}}>
        <Typography variant="h4" color="light-gray-text.main" noWrap>{item.title}</Typography>
        </Box>
        <Box flex={1} flexDirection={{xs:"column", lg:"row"}}>                 
        <Typography variant="h4">{item.description}</Typography>
    </Box>
</Box>

export default DetailsRow